"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("App error:", error);
  }, [error]);

  const isWebpackModuleError =
    error.message?.includes("Cannot read properties of undefined") &&
    error.message?.includes("reading 'call'");

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 p-8">
      <AlertCircle className="h-12 w-12 text-destructive" />
      <h2 className="text-lg font-semibold">
        {isWebpackModuleError ? "Page needs a refresh" : "Something went wrong"}
      </h2>
      <p className="max-w-md text-center text-sm text-muted-foreground">
        {isWebpackModuleError
          ? "This can happen after a new deployment or when the app was updated. Refreshing the page usually fixes it."
          : error.message}
      </p>
      <Button onClick={() => window.location.reload()} variant="default">
        Refresh page
      </Button>
      {!isWebpackModuleError && (
        <Button onClick={reset} variant="outline">
          Try again
        </Button>
      )}
    </div>
  );
}
